/**
 * HTML Element
 *
 */

import Anchor from './Anchor'

const Link = Anchor
export default Link
